module.exports = __webpack_public_path__ + "static/media/LK_White_Alarm.1c004f4d.svg";